import type { Package } from '../config/api'

// The franchise_packages API ignores the `price` param, so price filtering
// has to happen client-side against price_cents.

export interface PriceRange {
  min?: number
  max?: number
}

interface PriceFilterInput {
  price?: string
  price_min?: number
  price_max?: number
}

// The filter dropdowns use shorthand in thousands ("5-10" = R5000-R10000,
// "20" = R20000 upwards). Values of 1000+ are treated as rand amounts.
const toRand = (value: string): number | undefined => {
  const n = parseFloat(value.replace(/[^\d.]/g, ''))
  if (!Number.isFinite(n)) return undefined
  return n < 1000 ? n * 1000 : n
}

export const getPriceRange = (filters: PriceFilterInput): PriceRange | null => {
  if (filters.price && filters.price.trim()) {
    const [minPart, maxPart] = filters.price.split('-')
    const range: PriceRange = {
      min: minPart ? toRand(minPart) : undefined,
      max: maxPart ? toRand(maxPart) : undefined,
    }
    return range.min !== undefined || range.max !== undefined ? range : null
  }
  if (filters.price_min || filters.price_max) {
    return { min: filters.price_min || undefined, max: filters.price_max || undefined }
  }
  return null
}

export const matchesPriceRange = (pkg: Package, range: PriceRange): boolean => {
  const price = (pkg.price_cents || 0) / 100
  if (range.min !== undefined && price < range.min) return false
  if (range.max !== undefined && price > range.max) return false
  return true
}
